<div
	class="tab-container" 
	[ngStyle]="{ 'max-width': width, 'width': width }"
	[ngClass]="{ 'iphone-5': screenWidth === 320 }"
	*ngIf="tabs.length"
>
	<div
		*ngFor="let tab of tabs; index as i"
		class="tab"
		[ngClass]="{
			active: _activeTab === (tab.id?tab.id:(tab.name ? tab.name : tab)),
			inactive: _activeTab !== (tab.id?tab.id:(tab.name ? tab.name : tab)),
			disabled: _disabled,
			'three-tabs': tabs?.length === 3
		}"
		(click)="_tabChanged(tab.id?tab.id:(tab.name ? tab.name : tab))"
	>
		<div
			class="tab-title"
			[ngClass]="{ 'has-icon': tab?.icon, 'pos-r': tabs?.length === 3 }"
		>
			<img
				*ngIf="tab?.icon"
				[src]="_disabled ? tab.disabledIcon : tab?.icon"
				[style.marginLeft.px]="tab?.iconLeftMargin"
			/>
			<span class="tab-text" [innerHTML]=" tab.name
			? tab.name
			: screenWidth < 415 && responsiveTabs.length > 0
			? responsiveTabs[i]
			: tab">
					<!-- {{
						tab.name
							? tab.name
							: screenWidth < 415 && responsiveTabs.length > 0
							? responsiveTabs[i]
							: tab
					}} -->
			</span>
			<span
				[ngClass]="{
					'border-hider': _activeTab === (tab.name ? tab.name : tab)
				}"
			></span>
		</div>
	</div>

	<div [ngClass]="_disabled ? 'disabled form-controls' : 'form-controls'">
		<ng-content></ng-content>
	</div>
</div>
